export default "__VITE_ASSET__CZYY4FUp__"